import mirrorCreator from "mirror-creator";

export default mirrorCreator([
    "SWITCH_MAP",
    "MERGE_MAP_VIEWPORT",
    "MERGE_MAP_DATA",
    "MERGE_PARAMS",
    "CHANGE_CENTER",
    "MERGE_MAP_HEADER",
    "GET_PLATON_POINTS",
    "GET_POSTAMAT_POINTS",
    "GET_PAYMENT_POINTS",
    "GET_ROAD_RESTRICTIONS",
    "GET_ROAD_RESTRICTION_TYPES",
    "SET_REGION_DRYING_PERIODS",
]);
